import { render, staticRenderFns } from "./externalSsoComponent.vue?vue&type=template&id=05ea7f72&scoped=true"
import script from "./externalSsoComponent.vue?vue&type=script&lang=js"
export * from "./externalSsoComponent.vue?vue&type=script&lang=js"
import style0 from "./externalSsoComponent.vue?vue&type=style&index=0&id=05ea7f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ea7f72",
  null
  
)

export default component.exports